import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    all: inherit;
    padding: ${({ index, padding = 2 }) => !index ? `0 0 ${padding}em 0` : `${padding}em 0`};
    border-bottom: ${({ lineBreak }) => lineBreak ? 1 : 0}px solid ${({ theme }) => theme.secondary}40;
`

const PageBreak = ({ children, ...props }) => {
    if (children instanceof Array) {
        children = children.filter(e => e);
        return (
            children.map((e, i) => (
                <Wrapper key={`${i}-pageBreak`} lineBreak={i !== children.length - 1} index={i} {...props}>
                    {e}
                </Wrapper>
            ))
        )
    }

    return children;
};

export default PageBreak;
